import React, { useState } from "react";
import { STAFF_PERM_ACTIONS, staffCanDebug } from "../permissions/checks";

export default function PermissionDebugPanel({state,platformCtx,isRTL}){
  const [open,setOpen]=useState(false);
  const {users}=state;
  if(!open)return(
    <div style={{marginTop:12}}>
      <button className="btn btn-g btn-xs" style={{fontSize:11}} onClick={()=>setOpen(true)}>
        {isRTL?"تشخيص الصلاحيات":"Debug Permissions"}
      </button>
    </div>
  );
  return(
    <div className="card" style={{marginTop:12}}>
      <div className="ch">
        <div className="ct" style={{fontSize:12}}>{isRTL?"تشخيص الصلاحيات":"Permission Resolution Debug"}</div>
        <button className="btn btn-g btn-xs" onClick={()=>setOpen(false)}>×</button>
      </div>
      <div style={{padding:"12px 16px",fontSize:12,fontFamily:"var(--fm)"}}>
        {(users||[]).filter(u=>u.active).map(u=>(
          <div key={u.id} style={{marginBottom:16}}>
            <div style={{fontWeight:600,fontSize:13,marginBottom:6}}>{u.name} <span style={{color:"var(--g400)",fontWeight:400}}>({u.role})</span></div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:6}}>
              {STAFF_PERM_ACTIONS.map(action=>{
                const dbg=staffCanDebug(action,u,state,platformCtx);
                return(
                  <div key={action} style={{padding:"6px 10px",borderRadius:8,background:dbg.granted?"var(--grn-bg,#e6f7e9)":"var(--g50)",border:`1px solid ${dbg.granted?"var(--grn-bd,#b8e6c0)":"var(--g200)"}`}}>
                    <div style={{fontSize:11,fontWeight:600,color:dbg.granted?"var(--grn)":"var(--g500)"}}>{dbg.granted?"✓":"✗"} {action}</div>
                    <div style={{fontSize:10,color:"var(--g400)",marginTop:2}}>{dbg.reason}</div>
                    <div style={{fontSize:9,color:"var(--g300)",marginTop:2}}>
                      {dbg.chain.map((c,i)=><span key={i}>{c.layer}: [{c.roles.join(",")}]{i<dbg.chain.length-1?" → ":""}</span>)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
